import { render, staticRenderFns } from "./ApplicantMessageAttachmentFile.vue?vue&type=template&id=764c075b"
import script from "./ApplicantMessageAttachmentFile.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageAttachmentFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports